import { Button, Snackbar } from "@mui/material";

type Props = { open: boolean; message: string; okLabel: string; onClose: () => void };

/** Square's closing note, bottom-left, only after a completed tour. */
const TourFinishSnackbar = ({ open, message, okLabel, onClose }: Props) => (
  <Snackbar
    open={open}
    onClose={(_e, reason) => reason !== "clickaway" && onClose()}
    autoHideDuration={8000}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    message={message}
    action={
      <Button color="inherit" size="small" onClick={onClose}>
        {okLabel}
      </Button>
    }
  />
);

export default TourFinishSnackbar;
